import { render } from "./Sanshubio.vue?vue&type=template&id=22bf7ac3&scoped=true"
import script from "./Sanshubio.vue?vue&type=script&lang=js"
export * from "./Sanshubio.vue?vue&type=script&lang=js"

import "./Sanshubio.vue?vue&type=style&index=0&id=22bf7ac3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bf7ac3"]])

export default __exports__